/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {ElementRef, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import {SharedModule} from '../../shared/modules/shared.module';
import {NavbarComponent} from './components/navbar.component';
import {NavbarProfileComponent} from './components/profile/profile.component';
import {NavbarMenuComponent} from './components/menu/menu.component';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TranslateModule} from '@ngx-translate/core';
import {ActiveMenuDirective} from './directive/active-menu.directive';
import {AccountResourceService} from "../../shared/services/account-resource.service";
import {PrincipalService} from "../../shared/services/principal.service";
import {AppComponent} from "../../app.component";
import {LoginService} from "../../shared/services/login.service";
import {ProfileService} from "../../shared/services/profile.service";
import { NavMobileComponent } from './components/nav-mobile/nav-mobile.component';

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
    CommonModule,
    PopoverModule.forRoot(),
    TranslateModule.forChild(),
    NgIdleKeepaliveModule.forRoot()
  ],
  declarations: [NavbarComponent, ActiveMenuDirective, NavbarProfileComponent, NavbarMenuComponent, NavMobileComponent],
  exports: [NavbarComponent, NavbarProfileComponent],
  providers: [
    AppComponent,
    AccountResourceService,
    PrincipalService,
    LoginService,
    ProfileService
  ],
})
export class NavbarModule {
}
